jQuery(function(){
    var $table = jQuery('#facilities');
    var region_filter = null;

    jQuery('body').on('change', '#search-city[data-api-link="search-city-wait-times"]', function(e){

        e.preventDefault();

		var $table = jQuery('#wait-times-table');
		var get = { };
        var $city = jQuery('#search-city');

        jQuery('#load-more-wait-times').show();

        region_filter = $city.val();
        get.region = region_filter;

		jQuery.get('/api/roadside_service_wait_times', get, function(response){
			$table.find('tbody').remove();
            var $html = jQuery('<tbody>' + response + '</tbody>');
			$table.append($html);

			if($html.find('.table__column--no-results').length == 1) {
                jQuery('#load-more-wait-times').hide();
            }
		});

		return false;
	});

    jQuery('body').on('click', '#load-more-wait-times', function(e){

		e.preventDefault();

		var $table = jQuery('#wait-times-table');
		var get = { };

		var records = $table.find('.table__row').length;
        get.offset = records;

        if (region_filter !== null) {
            get.region = region_filter;
        }


		jQuery.get('/api/roadside_service_wait_times', get, function(response){

            var $html = jQuery('<tbody>' + response + '</tbody>');

            $table.append($html);

            if ($html.find('.table__column--no-results').length == 1) {
                jQuery('#load-more-wait-times').hide();
            }
		});

		return false;
	});


});
